module.exports = __webpack_public_path__ + "img/14.3b5bb8eb.jpg";